<ng-container *ngIf="tabsContent$ | async as tabsContent">
  <ul
    ngbNav
    #nav="ngbNav"
    [(activeId)]="active"
    class="nav-tabs"
    [destroyOnHide]="false"
  >
    <li [ngbNavItem]="1">
      <button ngbNavLink class="nav-link" translate>
        CONTRACT_TABS_GENERAL_INFORMATIONS
        <ng-container
          *ngIf="!!this.form.controls['generalInformationFormGroup'] && this.form.controls['generalInformationFormGroup']?.touched && this.form.controls['generalInformationFormGroup']?.invalid">
          <span class="ps-1">
            <ng-container *ngIf="errorsDescription$ | async as errors; else noError">
              <ng-container *ngFor="let error of errors.children">
                <span class="badge text-bg-danger"
                      *ngIf="error.groupName === 'generalInformationFormGroup'">{{ error.count }}</span>
              </ng-container>
            </ng-container>
            <ng-template #noError>
              <span class="dot"></span>
            </ng-template>
          </span>
        </ng-container>
      </button>
      <ng-template ngbNavContent>
        <app-contract-form-general-informations />
      </ng-template>
    </li>


    <li [ngbNavItem]="tabContent.index + 2"
        *ngFor="let tabContent of tabsContent; count as count; last as isLast; trackBy: trackByTabsContent">
      <button ngbNavLink class="nav-link" translate>
        {{ tabContent.title }}
        <ng-container
          *ngIf="!!tabContent.formGroupName &&
                !!this.form.controls[tabContent.formGroupName] &&
                this.form.controls[tabContent.formGroupName].touched &&
                this.form.controls[tabContent.formGroupName].invalid">
          <span class="ps-1">
            <ng-container *ngIf="errorsDescription$ | async as errors; else noError">
              <ng-container *ngFor="let error of errors.children">
                <span class="badge text-bg-danger"
                      *ngIf="error.groupName === tabContent.formGroupName">{{ error.count }}</span>
              </ng-container>
            </ng-container>
            <ng-template #noError>
              <span class="dot"></span>
            </ng-template>
          </span>
        </ng-container>

      </button>
      <ng-template ngbNavContent>
        <ng-container *ngComponentOutlet="tabContent.component"/>
      </ng-template>
    </li>


    <li [ngbNavItem]="tabsContent.length + 3">
      <button ngbNavLink class="nav-link" translate>
        CONTRACT_TABS_PAYMENT_SPLITTING
        <ng-container
          *ngIf="!!this.form.controls['paymentSplittingFormGroup'] && this.form.controls['paymentSplittingFormGroup']?.touched && this.form.controls['paymentSplittingFormGroup']?.invalid">
          <span class="ps-1">
            <ng-container *ngIf="errorsDescription$ | async as errors; else noError">
              <ng-container *ngFor="let error of errors.children">
                <span class="badge text-bg-danger"
                      *ngIf="error.groupName === 'paymentSplittingFormGroup'">{{ error.count }}</span>
              </ng-container>
            </ng-container>
            <ng-template #noError>
              <span class="dot"></span>
            </ng-template>
          </span>
        </ng-container>
      </button>
      <ng-template ngbNavContent>
        <app-contract-form-payment-splitting/>
      </ng-template>
    </li>

    <li [ngbNavItem]="tabsContent.length + 4">
      <button ngbNavLink class="nav-link" translate>
        CONTRACT_TABS_COMMISSIONS
        <ng-container
          *ngIf="!!this.form.controls['commissionFormGroup'] && this.form.controls['commissionFormGroup']?.touched && this.form.controls['commissionFormGroup']?.invalid">
          <span class="ps-1">
            <ng-container *ngIf="errorsDescription$ | async as errors; else noError">
              <ng-container *ngFor="let error of errors.children">
                <span class="badge text-bg-danger"
                      *ngIf="error.groupName === 'commissionFormGroup'">{{ error.count }}</span>
              </ng-container>
            </ng-container>
            <ng-template #noError>
              <span class="dot"></span>
            </ng-template>
          </span>
        </ng-container>
      </button>
      <ng-template ngbNavContent>
        <app-contract-form-commission/>
      </ng-template>
    </li>

    <li [ngbNavItem]="tabsContent.length + 5">
      <button ngbNavLink class="nav-link" translate>
        CONTRACT_TABS_MARKETING
        <ng-container
          *ngIf="!!this.form.controls['marketingFormGroup'] && this.form.controls['marketingFormGroup']?.touched && this.form.controls['marketingFormGroup']?.invalid">
          <span class="ps-1">
            <ng-container *ngIf="errorsDescription$ | async as errors; else noError">
              <ng-container *ngFor="let error of errors.children">
                <span class="badge text-bg-danger"
                      *ngIf="error.groupName === 'marketingFormGroup'">{{ error.count }}</span>
              </ng-container>
            </ng-container>
            <ng-template #noError>
              <span class="dot"></span>
            </ng-template>
          </span>
        </ng-container>
      </button>
      <ng-template ngbNavContent>
        <app-contract-form-marketing/>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</ng-container>
